import request from '@/router/axios';

/**
 * 获取年份列表
 * @param {*} params 
 * @returns 
 */
export const getYearList = () => {
  return request({
    url: '/api/blade-targetConfig/targetConfig/list',
    method: 'get',
    params: {}
  })
}

/**
 * 新增年份
 * @param {*} data 
 * @returns 
 */
export const addYear = (data) => {
  return request({
    url: '/api/blade-targetConfig/targetConfig/save',
    method: 'post',
    data: {
      ...data
    }
  })
}

/**
 * 获取对应年份的年度目标
 * @param { Object } params 
 * @param { Number } params.year 年份
 * @returns 
 */
export const getAnnualGoal = (params) => {
  return request({
    url: '/api/blade-targetConfig/targetConfig/getTargetByYear',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 * 修改年度目标
 * @param {*} data 
 * @returns 
 */
export const updateAnnualGoal = (data) => {
  return request({
    url: '/api/blade-targetConfig/targetConfig/update',
    method: 'post',
    data: {
      ...data
    }
  })
}

/**
 * 获取列表
 */
export const getTargetStats = (params) => {
  return request({
    url: '/api/blade-targetConfig/targetConfig/sureCount',
    method: 'get',
    params: {
      ...params
    }
  })
}
